export class UtilityService {
  public static isNullOrEmpty(value: string | null | undefined) {
    return !value || value === undefined || value === '' || value.length === 0;
  }
  public static isNullOrEmpty_Array(value: string[] | null | undefined) {
    return !value || value === undefined || value.length === 0;
  }
  public static isNumber(value: string | null) {
    return value != null && value !== '' && !isNaN(Number(value.toString()));
  }
  public isNullOrEmpty(value: string) {
    return !value || value === undefined || value === '' || value.length === 0;
  }
  public isNull(value: any) {
    return !value || value === undefined;
  }
  public replace(arg: any) {
    return String(arg).replace('.', ' : ');
  }
  public addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  public getDate(str: string) {
    if (str !== '' && str.length > 10) {
      const d = new Date(str).toDateString();
      //  d=  new Date(str).toLocaleDateString()
      // let d2 = new Date(str);
      // let fd = d2.toLocaleDateString() + ' ' + d2.toTimeString().substring(0, d2.toTimeString().indexOf("GMT"));

      return d;
    }
    return str;
  }
  public static b64toBlob(b64Data: string, contentType = '') {
    const byteCharacters2 = atob(b64Data);
    const byteNumbers = new Array(byteCharacters2.length);
    for (let i = 0; i < byteCharacters2.length; i++) {
      byteNumbers[i] = byteCharacters2.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob2 = new Blob([byteArray], { type: contentType });
    return blob2;
  }
  public static b64toUrl(b64Data: string, contentType = '') {
    const fileUrl = URL.createObjectURL(this.b64toBlob(b64Data, contentType));
    return fileUrl;
  }
}

export default UtilityService;
